import { useNavigate } from 'react-router-dom';
import './Box.scss';

export default function Box({ title, url, password = false, children }) {

    const navigate = useNavigate();

    function go() {
        if (!url)
            return console.warn('No URL provided for the box.');
        if (password) {
            const userPassword = prompt('Enter the password to access this link:');
            if (userPassword !== password) {
                alert('Incorrect password.');
                return;
            }
        }
        navigate(url);
    }

    return (
        <div id="box" className={url ? 'box-with-link box' : 'box'} onClick={url ? go : null}>
            {title && (
                <div className="box-title">
                    {title}
                </div>
            )}
            <div className="box-content">
                {children}
            </div>
        </div>
    );
}